var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOfferIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "https://www.w3.org/2000/svg",
    width: 34,
    height: 34
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "offer-icon_svg__a",
    width: "114.7%",
    height: "118.9%",
    x: "-7.5%",
    y: "-8.5%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.206457605 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#offer-icon_svg__a)",
    transform: "translate(-12 -117)",
    fill: "#FF6D38",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35 134a2.177 2.177 0 00-1.136-1.93.127.127 0 01-.06-.144 2.207 2.207 0 00-2.73-2.73.125.125 0 01-.144-.06 2.209 2.209 0 00-3.86 0 .125.125 0 01-.144.06 2.209 2.209 0 00-2.73 2.73.125.125 0 01-.06.144 2.209 2.209 0 000 3.86.127.127 0 01.06.145 2.209 2.209 0 002.73 2.73.125.125 0 01.144.06 2.209 2.209 0 003.86 0 .125.125 0 01.144-.06 2.208 2.208 0 002.73-2.73.128.128 0 01.06-.145A2.175 2.175 0 0035 134zm-4.171 2.743a.915.915 0 110-1.83.915.915 0 010 1.83zm-3.915.05a.5.5 0 01-.705-.705l4.877-4.877a.5.5 0 11.705.705l-4.877 4.877zm.257-5.536a.913.913 0 110 1.829.914.914 0 010-1.829z"
  }))));
}
export default SvgOfferIcon;